export const Pharmacy = {
    path: '/pharmacies',
    name: 'pharmacies',
    component: () => import('@/views/Customer/PharmacyPage.vue'),
    children: [
        {
            path: '/pharmacies/add',
            name: 'pharmacies.add',
            component: () => import('@/views/Customer/Form/CustomerForm.vue'),
            props: {addAction: true, type: 'pharmacy'},
        },
        {
            path: '/pharmacies/edit/:id',
            name: 'pharmacies.edit',
            component: () => import('@/views/Customer/Form/CustomerForm.vue'),
            props: {updateAction: true, type: 'pharmacy'}
        },
        {
            path: '/pharmacies/delete/:id',
            name: 'pharmacies.delete',
            component: () => import('@/views/Customer/Form/CustomerForm.vue'),
            props: {deleteAction: true, type: 'pharmacy'}
        },
        {
            path: '/pharmacies/view/:id',
            name: 'pharmacies.view',
            component: () => import('@/views/Customer/Form/CustomerForm.vue'),
            props: {viewAction: true, type: 'pharmacy'}
        },
        {
            path: '/pharmacies/visit/add/:customerId',
            name: 'pharmacies.visit.add',
            component: () => import('@/views/Visit/Form/VisitForm.vue'),
            props: {addAction: true, type: 'pharmacy'},
        },
        {
            path: '/pharmacies/visit/edit/:id',
            name: 'pharmacies.visit.edit',
            component: () => import('@/views/Visit/Form/VisitForm.vue'),
            props: {updateAction: true, type: 'pharmacy'},
        },
        {
            path: '/pharmacies/visit/delete/:id',
            name: 'pharmacies.visit.delete',
            component: () => import('@/views/Visit/Form/VisitForm.vue'),
            props: {deleteAction: true, type: 'pharmacy'},
        },
        {
            path: '/pharmacies/visit/view/:id',
            name: 'pharmacies.visit.view',
            component: () => import('@/views/Visit/Form/VisitForm.vue'),
            props: {viewAction: true, type: 'pharmacy'},
        },
    ]
}